import { idFactory } from "./idFactory";

export const previewIds = idFactory();

export default { previewIds };
